import { Main } from "App/global-style";
import { cartId } from "Components/InsuranceDetailsCard/EditableInsuranceDetailsCard/EditableCardFooter/utils/getEditUrl/testUtils";
import { LoginErrorPage } from "Components/LoginErrorPage/LoginErrorPage";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { MainPath } from "Constants/constants";
import { Redirect } from "react-router";
import {
  OperationType,
  UserIdentificationEntity,
} from "Store/userIdentification/userIdentificationInterfaces";

import React from "react";

interface Props {
  userIdentificationEntity: UserIdentificationEntity;
}

export const UserIdentificationHandler = ({
  userIdentificationEntity,
}: Props): React.ReactElement => {
  if (
    !!cartId &&
    userIdentificationEntity.error &&
    userIdentificationEntity.error.operationType ===
      OperationType.GET_OFFER_FROM_ADVISOR_REQUEST
  ) {
    return <Redirect to={`/${MainPath.OFFER_ACCEPT}/${cartId}`} />;
  } else if (userIdentificationEntity.error !== null) {
    return <LoginErrorPage />;
  }
  return (
    <Main>
      <ThemedSpinner />
    </Main>
  );
};
